import SheetsPage from "@/components/products/sheets/SheetsPage"

type Props = {}

const index = (_props: Props) => {
  return <SheetsPage />
}

export default index
